import appConfig from "./config"
import { AppConfig } from "@hornet-web-react/core/services/AppConfig"

type HornetAppConfig = AppConfig

export default appConfig as HornetAppConfig
